module.exports = __webpack_public_path__ + "static/media/ULCO.1a1f41d9.png";